import { gql } from '@apollo/client'

export const fetchFirmTasksQuery = gql`
  query FetchFirmTasks($firmId: Int!) {
    firm(firmId: $firmId) {
      id
      tasks(includeArchived: false, populateArchived: false, sortAlphabetically: true) {
        id
        displayName
        isArchived
        timeCreated
        launchDate
        offboardDate
        taskType
        leasingInfo {
          propertyType
        }
      }
    }
  }
`
